import React, { Fragment, useEffect, useRef, useState } from 'react'
import NEH from './NappsEventHandlers'
import { Link, useNavigate } from "react-router-dom";
import AppBoxes, { SearchAppBoxes } from "./AppBoxes";
import axios from 'axios';

// class SearchModes extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       isSearchComponent: true,
//       app_name_search_string: '',
//       search_result: [],
//       search_empty_response_text: '',
//     }
//     // this.closeSearchTemplate = this.closeSearchTemplate.bind(this);
//     this.handleSearchKeyUp = this.handleSearchKeyUp.bind(this)
//   }

//   componentDidMount() {
//   }

//   componentWillUnmount() { }

//   componentDidUpdate(prevProps, prevState, snapshot) {
//     // if (prevState !== this.state.search_result) {
//     //   const isEmptySearch = this.state.search_result.length === 0;
//     //   // const search_empty_result_text = isEmptySearch ? 'No'
//     //   this.setState({
//     //     search_result: this.state.search_result
//     //   })
//     // }
//   }

//   async handleSearchKeyUp(event) {
//     // console.log(event.currentTarget.value);
//     console.log(event.currentTarget.form)
//     this.setState({
//       app_name_search_string: event.currentTarget.value,
//     })
//     const search_api_url = `${process.env.REACT_APP_BASE_URL}/app/?search=${event.target.value}`;
//     const search_fetch_init = {
//       method: 'GET',
//       headers: {
//         'Accept': 'application/json',
//         'Origin': '*',
//       },
//       // body: new FormData(event.currentTarget.form),	// Blob, BufferSource, FormData, URLSearchParams, USVString, ReadableStream
//       modes: 'cors',  // options: cors, no-cors, same-origin
//       // credentials: "same-origin",	// omit, same-origin, include,
//       // cache: "default",   // options: default, no-store, reload, no-cache, force-cache, only-if-cached
//       // redirect: "",	// follow, error (error if redirect occur from response), manual
//       // referrer: "",	// e.g., "", about:client (- A USVString)
//       // referrerPolicy: "",	// no-referrer, no-referrer-when-downgrade, same-origin, origin, strict-origin, origin-when-cross-origin, strict-origin-when-cross-origin or unsafe-url
//       // Integrity: ""	// e.g., sha256-BpfBw7ivV8q2jLiT13fxDYAe2tJllusRSZ273h2nFSE=
//       // keepalive: ""	//	A replacement for Navigator.sendBeacon() API
//       // signal: ""	//	An AbortSignal object instance
//     }
//     await fetch(search_api_url, search_fetch_init)
//       .then(response => {
//         if (response.status >= 400) {
//           return null
//         }
//         return response.json()
//       })
//       .then(data => {
//         console.log(data)
//         this.setState({
//           search_result: data || [],
//         }, () => this.setState({
//           search_empty_response_text: this.state.search_result.length === 0 ? 'No Search Result' : 'Found results.',
//         }));
//         console.log(this.state.search_result)
//       }).catch(error => {
//         console.log(`Error occurred performing search: ${error}`)
//       })
//   }

//   searchTemplate() {
//     <Fragment key={this.state.isSearchComponent}>
//       ABADJBSHD
//     </Fragment>
//     // <template id="id-search-page-template" className="search-page-template"></template>;
//   }

//   render() {
//     const { search_result } = this.state;
//     return (
//       // {/* SEARCH TEMPLATE - JUNE 13, 2022 */}
//       <section id="id-search-page-fragment" className="search-page-fragment">
//         <section id="id-search-panel-page-navigation-container" className="modes-navigation-container">
//           {/* <span id="id-modes-navigation-close-trigger" className="fa fa-times fa-2x modes-navigation-close-trigger-right bg-green" onClick={new NEH().closeSearchTemplate}></span> */}
//           {/* <span className="modes-navigation-title">
// 						<span className="fa fa-search fa-lg modes-navigation-icon"></span>
// 						Search
// 					</span> */}
//           <form action={"get"} id="id-napps-search-form" className="napps-search-form flex flex-column">
//             <div id="id-napps-search-form-input-container" className="align-self-center pad-y1 w-safe-12">
//               <input type="search" name="app_name" id="id-napps-search-form-input"
//                 className="pct:w-100 h-8 self-align-center radius pad-l8 pad-r3 text-center focus:text-left shadow-smt focus:radius2-sm focus:bg-lighter focus:shadow-initial outline-0"
//                 placeholder="Search Latest and Existing Apps..." onKeyUp={this.handleSearchKeyUp} />
//             </div>
//           </form>
//         </section>
//         <section className="modes-body-container">
//           {/* This is where the search items will appear. */}
//           <section id="id-napps-search" className="modes-show modes pct:h-100" onClick={this.closeSearchModes}>
//             {/*<span id="id-modes-navigation-close-trigger"*/}
//             {/*      className="fa fa-times fa-2x modes-navigation-close-trigger-right fixed top-1 left-2 squircle-6 mg-t1-sm bg-lighter z-index-1000"*/}
//             {/*      onClick={new NEH().closeSearchTemplate}></span>*/}
//             <Link to={"/"} id="id-modes-navigation-close-trigger"
//               className="fa fa-times fa-2x modes-navigation-close-trigger-right fixed top-1 left-2 squircle-6 mg-t1-sm bg-lighter z-index-1000"></Link>
//             <section className="modes-inner-cover modes-inner-cover-full pct:h-100"
//               onClick={this.closeSearchModesInner}>
//               <section className="search-result-container flex flex-column pct:h-100">
//                 {/* Locate the search bar. */}
//                 {search_result.length}
//                 {search_result.length > 0 ? search_result.map((each_search_result) => {
//                   return (
//                     <div className="mg-y3 border radius">{each_search_result.app_name}</div>
//                   )
//                 }) : <div className="flex flex-column justify-center align-center bg-inherit">
//                   {this.state.search_empty_response_text !== '' ? <span
//                     className="d-block mg-auto pct:w-72 font-medium sm:font-light font-32">No search results.</span> : ''}
//                 </div>
//                 }
//                 {this.props.children}
//               </section>
//             </section>
//           </section>
//         </section>
//       </section>
//     )
//   }
// }

/* function SearchModes(props) {
  return(
    <section id="id-napps-search" className={props.modes_show ? modes_classname+" modes-show" : modes_classname} onClick={closeSearchModes}>
    </section>
  );
} */

// export default SearchModes

const Search = () => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const searchItemsContainerRef = useRef(null);
  const [searchResult, setSearchResult] = useState(null);
  const [searchEmptyResponseText, setSearchEmptyResponseText] = useState('');
  const [fetchMoreData, setFetchMoreData] = useState(false);
  const [moreSearchResult, setMoreSearchResult] = useState(null)

  let appNameSearchString;

  const handleSearchKeyDown = (event) => {
    // alert(event.keyCode)
    if (event.keyCode === 32) {
      event.preventDefault();
    }
    if (event.isComposing || event.keyCode === 229) {
      let ss = event.target.selectionStart - 1;
      let ss_value = ss || 0;
      let char = event.target.value.substr(ss_value, 1);
      const charCode = char.charCodeAt(0);
    }
  }

  const handleSearchKeyUp = (event) => {
    // console.log(event.currentTarget.value);
    // console.log(event.currentTarget.form)
    appNameSearchString = event.currentTarget.value;
    const accepted_alphanumerics = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_";
    const accepted_alphanumerics_list = accepted_alphanumerics.split("");
    if (event.key.toLowerCase() !== "unidentified") {
      if (!accepted_alphanumerics_list.includes(event.key)) {
        console.log(event.key + " not accepted")
        event.preventDefault();
        event.stopPropagation();
        return
      }
    }
    console.log("Should not print if input not between a-z")
    const searchApiUrl = `${process.env.REACT_APP_BASE_URL}/app/?search=${event.target.value}`;
    const searchFetchInit = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        // 'Origin': '*',
      },
      // body: new FormData(event.currentTarget.form),	// Blob, BufferSource, FormData, URLSearchParams, USVString, ReadableStream
      modes: 'cors',  // options: cors, no-cors, same-origin
      // credentials: "same-origin",	// omit, same-origin, include,
      // cache: "default",   // options: default, no-store, reload, no-cache, force-cache, only-if-cached
      // redirect: "",	// follow, error (error if redirect occur from response), manual
      // referrer: "",	// e.g., "", about:client (- A USVString)
      // referrerPolicy: "",	// no-referrer, no-referrer-when-downgrade, same-origin, origin, strict-origin, origin-when-cross-origin, strict-origin-when-cross-origin or unsafe-url
      // Integrity: ""	// e.g., sha256-BpfBw7ivV8q2jLiT13fxDYAe2tJllusRSZ273h2nFSE=
      // keepalive: ""	//	A replacement for Navigator.sendBeacon() API
      // signal: ""	//	An AbortSignal object instance
    }
    // fetch(searchApiUrl, searchFetchInit)
    axios(searchApiUrl, searchFetchInit)
      .then(response => {
        if (response.status >= 400) {
          return null
        }
        // return response.json()
        return response.data;
      })
      .then(data => {
        setSearchResult(data)
      }).catch(error => {
        console.log(`Error occurred performing search: ${error}`)
      })
  }

  useEffect(() => {
    const fetchConfig = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        // 'Origin': '*',
      },
      modes: 'cors',  // options: cors, no-cors, same-origin
      cache: 'default',   // options: default, no-store, reload, no-cache, force-cache, only-if-cached
    }
    axios(searchResult?.data?.next, fetchConfig)
      // .then((res) => res.json())
      .then((res) => res.data)
      .then((data) => {
        setMoreSearchResult(data.results);
        // if (data.next) {
        //   setNextPageData({ hasNextPage: true, next: data.next });
        // } else {
        //   setNextPageData({ hasNextPage: false, next: data.next })
        // }
      });
    // alert("Done fetching more data")
    return () => { }
  }, [fetchMoreData]);

  useEffect(() => {
    // handle Scroll check
    const scrollContainerElem = scrollContainerRef.current;
    const handleScroll = () => {
      // Get the last container height as on offset for the scroll calculation.
      // if (document.getElementById('id-latest-apps-container') !== null) {
      if (searchItemsContainerRef.current.lastElementChild !== null) {
        // const lastElement = document.getElementById('id-latest-apps-container').lastElementChild;
        const lastElement = searchItemsContainerRef.current.lastElementChild;
        const lastElementHeight = lastElement.clientHeight;
        if (scrollContainerElem.scrollHeight - scrollContainerElem.scrollTop - lastElementHeight <= scrollContainerElem.clientHeight) {
          // we've reached the bottom of the scrollContainerElem
          // console.log("Reached the bottom of the page.");
          setFetchMoreData(true);
        }
      }
    };

    scrollContainerElem.addEventListener("scroll", handleScroll);
    return () => { scrollContainerElem.removeEventListener("scroll", handleScroll) }
  }, []);

  const triggerFetchMoreSearchResult = () => {
    setFetchMoreData(true);
  }

  return (
    // {/* SEARCH TEMPLATE - JUNE 13, 2022 */}
    <section id="id-search-page-fragment" className="search-page-fragment vh:h-100 overflow-y-auto dark:bg-inherit" ref={scrollContainerRef}>
      <section id="id-search-panel-page-navigation-container" className="modes-navigation-container modes-navigation-container-nobg">
        {/* <span id="id-modes-navigation-close-trigger" className="fa fa-times fa-2x modes-navigation-close-trigger-right bg-green" onClick={new NEH().closeSearchTemplate}></span> */}
        {/* <span className="modes-navigation-title">
						<span className="fa fa-search fa-lg modes-navigation-icon"></span>
						Search
					</span> */}
        <form action={"get"} id="id-napps-search-form" className="napps-search-form flex flex-column justify-center align-item-center bg-white-solid z-100 lg:focus-within:bg-light dark:bg-000304 dark:lg:focus-within:bg-111314">
          <div
            id="id-napps-search-form-input-container"
            className="align-self-center flex flex-row align-items-center w-safe-12 bg-inherit"
          >
            <button
              type={"button"}
              id="id-modes-navigation-close-trigger"
              className="fa fa-arrow-left d-block font-16 square-8 lh-8 relative text-center radius-circle decoration-none bg-unset border-0 color-initial cursor-pointer hover:bg-whitesmoke dark:color-whitesmoke dark:hover:bg-222425"
              onClick={() => navigate(-1)}
            ></button>
            <label className={"flex flex-row align-items-center pct:w-100 bg-inherit"}>
              {/*<span className={"fa fa-search font-16 pad-x1"}></span>*/}
              <input
                type="search"
                name="app_name"
                id="id-napps-search-form-input"
                className="pct:w-100 h-10 align-self-center pad-l2 pad-r3 text-left outline-0 outline-none border-0 bg-inherit dark:color-whitesmoke lg:focus:bg-light lg:placeholder:font-semibold dark:lg:focus:bg-111314"
                placeholder="Search Apps..."
                onKeyUp={handleSearchKeyUp}
                onKeyDown={handleSearchKeyDown} />
            </label>
          </div>
        </form>
      </section>
      <section className="modes-body-container">
        {/* This is where the search items will appear. */}
        <section id="id-napps-search" className="pct:h-100">

          <section className="modes-inner-cover modes-inner-cover-ful overflow-y-auto">
            {/*{searchResult?.results?.length}*/}
            <section className="search-result-container flex flex-row flex-wrap justify-between align-items-start h-inherit pad-x2 lg:pad-x4 dark:pad-x-unset">
              {/* Locate the search bar. */}
              {
                searchResult?.results?.length > 0
                  ? searchResult.results.map((each_search_result) => {
                    return (
                      <div key={each_search_result.id} className="pct:w-100 mg-y2 radius dark:mg-y-1" ref={searchItemsContainerRef}>
                        <SearchAppBoxes truncateDescription={true} {...each_search_result} />
                        {moreSearchResult}
                      </div>
                    )
                  })
                  : <div className="flex flex-column justify-center align-center pct:w-100 bg-inherit dark:bg-000304">
                    {
                      searchResult?.results?.length === 0
                        ? <span
                          className="d-block mg-auto pct:w-72 lh-normal pad-y8 font-medium sm:font-light font-20 text-center color-gray dark:color-whitesmoke">No search result.</span>
                        : ''
                    }
                  </div>
              }
              {
                searchResult?.data?.next
                  ? <button type={"button"} className={"d-block mg-x-auto h-5 lh-5 font-9 font-bold border-0 bg-green-inverse color-green-dark pad-x2 radius"} onClick={() => triggerFetchMoreSearchResult}>
                    Load more result
                  </button>
                  : null
              }
              {/*{props.children}*/}
            </section>
          </section>
        </section>
      </section>
    </section>
  )
}
export default Search;